import { AxiosInstance } from 'axios';
import { plainToInstance } from 'class-transformer';
import { NotificationDTO } from '../commons/dtos/notification.dto';
import {
  IChatbotAPIResponse,
  IChatbotAPIResponsePagination
} from '../commons/interfaces/chatbotAPI.interface';
import {
  INotification,
  IUnreadNotificationCount
} from '../commons/interfaces/notification.interface';
import Axios from './axios.service';

export default class NotificationService {
  private request: AxiosInstance;

  constructor() {
    this.request = Axios.getInstance();
  }

  countUnreadNotifications = async (managerId: string) => {
    const bodyRequest = { managerId };
    const response = await this.request.post<IChatbotAPIResponse<IUnreadNotificationCount>>(
      '/notifications/unreads/count',
      bodyRequest
    );

    const data = response.data.data;

    return { data };
  };

  listNotifications = async (page: number) => {
    const response = await this.request.get<IChatbotAPIResponsePagination<INotification[]>>(
      '/notifications',
      { params: { pageSize: 10, page } }
    );

    const data = plainToInstance(NotificationDTO, response.data.data);

    return { data, pagination: response.data.pagination };
  };

  createNotificationSeenManager = async (notificationId: string, managerId: string) => {
    const endpoint = `notifications/${notificationId}/seen-managers`;
    return this.request.post(endpoint, { managerId });
  };
}
